(function ($) {
  if ($('.pageheader__media').length > 0) {
    const $jumpmenu = $('.jump-menu');

    if ($('.faded-nav')) {
      $(window).on('scroll', function () {
        var topNav = $('body')[0].getBoundingClientRect();

        if ($('.jump-menu').length > 0) {
          var jumpmenu = $('.jump-menu')[0].getBoundingClientRect();

          if ($jumpmenu.hasClass('white-background')) {
            if (jumpmenu.top > 122) {
              $jumpmenu.css({ opacity: '0', transition: '0.3s' });
              $jumpmenu.removeClass('white-background');
              $jumpmenu.css({ opacity: '1', transition: '0.3s' });
            }
          } else {
            if (jumpmenu.top <= 122) {
              $jumpmenu.css({ opacity: '0', transition: '0.3s' });
              $jumpmenu.addClass('white-background');
              $jumpmenu.css({ opacity: '1', transition: '0.3s' });
            }
          }
        }

        if ($('.faded-nav').hasClass('white-background')) {
          if (topNav.top >= 0) {
            $('.l-header').removeClass('sticky');
            $('.l-header.faded-nav').removeClass('white-background');
          }
        } else {
          if (topNav.top <= 10) {
            $('.l-header').addClass('sticky');
            $('.l-header.faded-nav').addClass('white-background');
          }
        }
      });
    }
  } else {
    $('.l-header').removeClass('faded-nav');

    $(window).on('scroll', function () {
      var topNav = $('body')[0].getBoundingClientRect();

      if ($('.l-header').hasClass('sticky')) {
        if (topNav.top >= 0) {
          $('.l-header').removeClass('sticky');
        }
      } else {
        if (topNav.top <= 10) {
          $('.l-header').addClass('sticky');
        }
      }
    });
  }
})(jQuery);
